import { useSelector } from 'react-redux';
import { Select } from '@timeedit/ui-components/antd';
// HOOKS
import useSelectSearch from '../../../../hooks/useSelectSearch';
// REDUX
import { selectOrganizationNodeLeaves } from '../../../../slices/organizationHierarchy.slice';

// TYPES
type Props = {
  standardOrganizationNodeId: string | undefined | null;
  onChange: (selectedStandardOrganizationId: string) => void;
};

const getControlValue = (val: string | null | undefined) => {
  return val && val !== '' ? val : undefined;
};

const StandardOrganizationSelector = ({
  standardOrganizationNodeId,
  onChange,
}: Props) => {
  const eligibleStandardOrganizations = useSelector(
    selectOrganizationNodeLeaves
  );

  const [options, setFilterQuery] = useSelectSearch(
    eligibleStandardOrganizations,
    'id',
    'name'
  );

  const onChangeStandardOrganizationNodeId = (val: string | undefined) => {
    if (val && val !== '') onChange(val);
  };

  return (
    <Select
      size="small"
      style={{ marginTop: '4px', width: '120px' }}
      value={getControlValue(standardOrganizationNodeId)}
      onChange={onChangeStandardOrganizationNodeId}
      placeholder="Standard node"
      showSearch
      onSearch={setFilterQuery}
      filterOption={false}
      popupMatchSelectWidth={false}
      options={options}
    />
  );
};

export default StandardOrganizationSelector;
